/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { useOnClickOutside } from "../../CommonMethods/OutsideClick";
import Button from "../Button";
import Filter from './Filter'
import { Tooltip } from 'react-tooltip'
import { checkPrivilege } from "../../CommonMethods/checkPrivilege";
import GlobalContext from "../Context/GlobalContext";
import EmailTemplate from "../../pages/ManageMerchants/components/EmailTemplate";
import Modalcustom from "../CustomModal";
// import { checkPrivilege } from "../../../CommonMethods/checkPrivilege";

const TopBar = ({
    branchUser,
    ApplyFilter,
    FilterData,
    AddButton,
    Tittle,
    SearchInput,
    AddButtonName,
    handleOnClickSearch,
    SearchValue,
    isClick,
    isFilter,
    FilterCheckbox,
    setFilterCheckBox,
    handleApplyFilter,
    filterCount,
    searchParams,
    BranchDisabled,
    createPath,
    handleExport,
    totaldata,
    tooltip,
    tooltipEmail,
    searchText,
    handleSidePopupClick,
    privilegeRequired,
    manageMerchantList,
    emailClick,
    setEmailClick,
    setCheckboxClick,
    sendemail,
    setSendemail,
    merchants,
    setMerchants,
    setemailList,
    setemailModal,
    List,
    emailList,
    admin
}) => {
    const location = useNavigate();
    const { setToastmessage, setToastErrorMessage, setToastError } = useContext(GlobalContext)
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const [search, setSearch] = useState('')
    const [timer, setTimer] = useState(0)
    // const [emailModal, setEmailModal] = useState(false)


    const outSideClick = useRef();
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false);
    });
    const [loading, setloading] = useState(false);

    const handleClick = async () => {
        setloading(true);
        // setEmailClick(false)
        await handleExport();
        setTimeout(() => {
            setloading(false);
        }, 2000);
    };

    const toggleSearch = () => {
        setIsSearchVisible(!isSearchVisible);
    };

    const handleEmailClick = () => {
        setEmailClick(true)
    }
    const handleCancelClick = () => {
        setEmailClick(false)
        setCheckboxClick(false)
    }
    const handleSearch = (newValue) => {
        setSearch(newValue);
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            handleOnClickSearch("search", newValue)
        }, 500)
        setTimer(newTimer)
    }
    const handleClose = () => {
        setEmailModal(false)
    }
    const hasPrivilege = checkPrivilege(privilegeRequired)
    return (
        <>
            <div className={`bg-white flex ${admin && 'pt-6 pl-4'} justify-between items-center pr-[66px] sticky top-0 left-0 z-[10]`}>
                <h1 className="font-playfair text-xl text-[#4B4B4B] font-[500] pl-1">{Tittle}</h1>
                <div className="flex justify-center items-center space-x-10">
                    {/* <div className="relative">
                        <input
                            type="text"
                            value={SearchValue}
                            data-testid="search"
                            onChange={(e) => handleOnClickSearch("search", e.target.value)}
                            placeholder={searchText}
                            className="w-[314px]  rounded-[8px] pl-[14px] pt-[6px] pb-3 z-1 border border-[#8E8E8E] placeholder:text-sm placeholder:font-normal placeholder:text-[#1F1F1F] outline-none"
                        />
                        <img
                            src="/assets/images/search.svg"
                            alt=""
                            className="absolute top-[11px] right-[19px]"
                        />
                    </div> */}
                    <div className="relative mr-[20px] h-[42px]">
                        <input
                            type="text"
                            // value={searchParams.search}
                            value={search}
                            data-testid="search"
                            onChange={(e) => handleSearch(e.target.value)}
                            placeholder="Name"
                            className={`w-[314px]  rounded-[8px] pr-10 pl-[14px] py-2 z-1 border border-[#8E8E8E] placeholder:text-sm placeholder:font-normal placeholder:text-[#1F1F1F] outline-none ${isSearchVisible ? 'block' : 'hidden'}`}

                        />
                        <img
                            src="/assets/images/search.svg"
                            alt=""
                            onClick={toggleSearch}
                            data-testid='search-btn'
                            // className="absolute top-[11px] right-[19px]"
                            className={`${isSearchVisible ? 'absolute top-[12px]  right-4' : 'mr-4 mt-[12px]'}   `}
                        />
                    </div>
                    {/* {(!sendemail && manageMerchantList && !admin) && <div data-tooltip-id="my-tooltip-2">
                        <img
                            src="/assets/images/Ghost.svg"
                            className="cursor-pointer hover:bg-[#FBEBF4] p-[2px] rounded-full"
                            // alt=""
                            onClick={() => setSendemail(true)} />
                        <Tooltip
                            id="my-tooltip-2"
                            place="bottom"
                            content={tooltipEmail} />
                    </div>} */}
                    {(sendemail === false && hasPrivilege) && <div data-tooltip-id="my-tooltip-2">
                        <img
                            src="/assets/images/Ghost.svg"
                            className="cursor-pointer hover:bg-[#FBEBF4] p-[2px] rounded-full"
                            data-testid="email-btn"
                            // alt=""
                            onClick={() => setSendemail(true)} />
                        <Tooltip
                            id="my-tooltip-2"
                            place="bottom"
                            content={tooltipEmail} />
                    </div>}
                    {isFilter && <Filter setIsFilterOpen={setIsFilterOpen} isFilterOpen={isFilterOpen} handleOnClickSearch={handleOnClickSearch} />}
                    {hasPrivilege && <Link to={createPath}>
                        <div className="relative " data-tooltip-id="my-tooltip-1">
                            <img
                                src="/assets/images/plus.svg"
                                className="cursor-pointer hover:bg-[#FBEBF4] p-3 rounded-full"
                                alt="add"
                                data-testid='add'
                            />
                            <Tooltip
                                id="my-tooltip-1"
                                place="bottom"
                                content={tooltip}
                            />
                        </div>
                    </Link>}

                    {/* {(sendemail && (List?.data.length > 0)) || admin && <Button
                        classKey={`px-4 py-[5px] border border-[#9E2064] w-[88px] text-primary rounded-[12px]`}
                        text="Export"
                        disabled={loading}
                        loading={loading}
                        type="button"
                        handleClick={handleClick}
                        color="pink"
                        testId='export-btn'
                    // testId={'export-btn'}
                    /> } */}
                    {(sendemail === false || admin === true) &&<Button
                        classKey={`px-4 py-[5px] border border-[#9E2064] w-[88px] text-primary rounded-[12px]`}
                        text="Export"
                        disabled={loading}
                        loading={loading}
                        type="button"
                        handleClick={handleClick}
                        color="pink"
                        testId='export-btn'
                    // testId={'export-btn'}
                    />}
                    {sendemail &&
                        <div className='flex gap-3'>
                            <Button
                                classKey={`px-4 py-[5px] border border-[#9E2064] w-[88px] text-primary rounded-[12px]`}
                                text="Cancel"
                                // disabled={exportLoading}
                                // loading={exportLoading}
                                type="button"
                                handleClick={() => {
                                    setMerchants('');
                                    setSendemail(false);
                                    setemailList([]);
                                }}
                                color=""
                                testId={'cancel-btn'}
                            />
                            <Button
                                classKey={`px-4 py-[5px] border bg-[#9E2064]  text-white rounded-[12px]`}
                                text="Send Email"
                                type="button"
                                handleClick={()=>{
                                    if(merchants !== 'select_all'){
                                        if(emailList.length > 0){
                                            setemailModal(true);
                                            return;
                                        }else{
                                            setToastError("Please choose at least one customer");
                                            return;
                                        }
                                    }
                                    setemailModal(true);
                                }
                                }
                                color=""
                                testId={'send-btn'}
                            />
                        </div>
                    }
                </div>
                {/* {emailModal == true && <Modalcustom open={emailModal} onClose={handleClose} container={'h-[365px] mx-auto mt-[100px]'}><EmailTemplate handleClose={handleClose} body={body} setBody={setBody} bodyError={bodyError} setBodyError={setBodyError} setBodyFocus={setBodyFocus} bodyFocus={bodyFocus} sendEmail={sendEmail} /></Modalcustom>} */}
            </div>
        </>
    );
};

export default TopBar;
